var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"river-flooding-layer"},[(_vm.selectedInfo)?_vm._l((_vm.selectedInfo.urls),function(url,i){return _c('l-image-overlay',{key:i,attrs:{"bounds":_vm.riverFloodingInfo.bounds[i],"url":url}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }